import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import reduce from 'lodash/reduce';
import map from 'lodash/map';
import { LinkElement } from '@els/els-react--link-element';
import { DOI_URL } from '@Components/Results/constants';
import htmlStripsService from '@Services/HtmlStripsService';

const BOLD_PROCESSOR = (val) => `<b>${val}</b>`;

const JOURNAL_FIELDS_MAPPER = [
  {
    field: 'issueTitle',
    processor: BOLD_PROCESSOR,
  },
  {
    field: 'issueYear',
    processor: BOLD_PROCESSOR,
  },
  {
    field: 'issueVolume',
  },
  {
    field: 'issueNo',
  },
  {
    field: 'articleNo',
  },
  {
    field: 'issuePages',
  },
];

function getDoiLink(doi) {
  return doi ? `${DOI_URL}${htmlStripsService.getTitleWithoutHtml(doi, 'full')}` : '';
}

function concatJournalStringHtml(journal, index, doi, withDoiLink = true) {
  const fields = reduce(
    JOURNAL_FIELDS_MAPPER,
    (resMemo, mapper) => {
      const value = journal[mapper.field];
      if (value) resMemo.push(mapper.processor ? mapper.processor(value) : value);
      return resMemo;
    },
    []
  );
  const fieldsString = fields.join(', ');
  const fieldsStringHtml = withDoiLink ? fieldsString : `[${fieldsString}]`;

  return fieldsStringHtml ? (
    <li key={index}>
      <InnerHTML tag="span" data-testid="document-journals" className="rx-element-literature" html={fieldsStringHtml} mode="escape" />
      {withDoiLink && doi && index === 0 && (
        <span>
          ,{' '}
          <LinkElement data-e2e="doi-link" href={getDoiLink(doi)} isExternal iconEmphasis className="doi-link">
            <InnerHTML html={doi} />
          </LinkElement>
        </span>
      )}
    </li>
  ) : null;
}

function DocumentJournals({ journals, withDoiLink, doi, className }) {
  const journalsStringHtml = useMemo(
    () => map(journals, (journal, index) => concatJournalStringHtml(journal, index, doi, withDoiLink)),
    [journals]
  );

  return (
    <div className={`document-journals ${className}`}>
      <ul>{journalsStringHtml}</ul>
    </div>
  );
}

DocumentJournals.propTypes = {
  journals: PropTypes.array.isRequired,
  withDoiLink: PropTypes.bool,
  doi: PropTypes.string,
  className: PropTypes.string,
};

export default DocumentJournals;
